module.exports = __webpack_public_path__ + "static/media/Blog6Img.77f1942f.webp";